import React, { useState } from 'react';
import { ShieldExclamationIcon } from '@heroicons/react/24/outline';

function ImpersonationBanner({ token, actingAsName, impersonatorUsername }) {
  const [exiting, setExiting] = useState(false);

  const handleExit = async () => {
    setExiting(true);
    try {
      await fetch('/api/v1/superadmin/impersonate/exit', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch {
      // Best-effort revocation — proceed to leave the session regardless,
      // since the token's 45-minute TTL is the backstop either way.
    }
    localStorage.removeItem('token');
    window.location.href = '/superadmin/schools';
  };

  return (
    <div
      style={{
        background: '#7C2D12',
        color: 'white',
        padding: '0.625rem 1.25rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.75rem',
        fontSize: '0.85rem',
        flexWrap: 'wrap',
        textAlign: 'center',
      }}
    >
      <ShieldExclamationIcon style={{ width: 18, height: 18, flexShrink: 0 }} />
      <span>
        {impersonatorUsername ? `${impersonatorUsername} is` : 'Currently'} signed in as <strong>{actingAsName || 'this account'}</strong> for support
      </span>
      <button
        onClick={handleExit}
        disabled={exiting}
        style={{
          background: 'white', color: '#7C2D12', border: 'none', borderRadius: 'var(--radius)',
          padding: '0.3rem 0.75rem', fontSize: '0.8rem', fontWeight: 600, cursor: 'pointer',
        }}
      >
        {exiting ? 'Exiting...' : 'Exit'}
      </button>
    </div>
  );
}

export default ImpersonationBanner;
